/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSpecialDetail.vue?vue&type=template&id=7236ba95&scoped=true"
import script from "./popSpecialDetail.vue?vue&type=script&lang=js"
export * from "./popSpecialDetail.vue?vue&type=script&lang=js"
import style0 from "./popSpecialDetail.vue?vue&type=style&index=0&id=7236ba95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236ba95",
  null
  
)

export default component.exports